import { PontoFisico } from '../../comum/modelos/ponto-fisico';
import { Component, OnInit, EventEmitter, Output, ViewEncapsulation, Input } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SetorPontoFisico } from '../../comum/modelos/setor-ponto-fisico';
import { ConfirmationService } from 'primeng/primeng';

@Component({
	selector: 'app-modal-setores-cliente',
	templateUrl: './modal-setores-cliente.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./modal-setores-cliente.component.css']
})
export class ModalSetoresClienteComponent implements OnInit {

	@Output() setorPontoFisicoEvent: EventEmitter<SetorPontoFisico[]>;
	@Input() pontosFisicos: PontoFisico[];
	@Input() habilitarSelecaoSetores: boolean;
	public setoresPontoFisico: SetorPontoFisico[];

	constructor(private modalService: NgbModal,
		private confirmationService: ConfirmationService) {
		this.setorPontoFisicoEvent = new EventEmitter<SetorPontoFisico[]>();
	}

	cadastrar(content) {
		if (!this.habilitarSelecaoSetores) {
			this.confirmationService.confirm({
				message: 'Selecione um Ponto F\u00edsico',
				rejectVisible: false,
				accept: () => {
				},
				reject: () => {
				}
			});
		} else {
			this.setoresPontoFisico = new Array<SetorPontoFisico>();
			const ngbModalOptions: NgbModalOptions = {
				backdrop: 'static',
				keyboard: false,
				windowClass: 'modalSetoresCliente',
				size: 'lg'
			};
			this.modalService.open(content, ngbModalOptions).result.then((result) => {
				this.setoresPontoFisico = result;
				this.setorPontoFisicoEvent.emit(this.setoresPontoFisico);
			}, (reason) => {
			});
		}
	}

	ngOnInit() {
	}

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/setor/modal-setores-cliente/modal-setores-cliente.component.ts